import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { handleGetFavorites } from '../../Components/FavoriteButton/utils';
import {
	setActiveLoginModal,
	setUserEmail,
	setUserName,
} from '../../app/features/userSlice';
import { useState } from 'react';
import { getWordpressData } from '../../services/getWordpressData';

export const useLoginWithWordpressPage = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { institutionCode } = useSelector((state) => state.institution);

	// Inputs
	const [passForm, setPassForm] = useState('');
	const [usernameForm, setUsernameForm] = useState('');

	// Errors
	const [usernameError, setUsernameError] = useState('');
	const [passwordError, setPasswordError] = useState('');
	const [loginError, setLoginError] = useState('');

	const [loadingLogin, setLoadingLogin] = useState(false);

	function validateInputs() {
		let isValid = true;

		if (usernameForm.trim().length === 0) {
			setUsernameError(t('Username or Email Address is required'));
			isValid = false;
		} else setUsernameError('');

		if (passForm.trim().length === 0) {
			setPasswordError(t('Password is required'));
			isValid = false;
		} else setPasswordError('');

		return isValid;
	}

	async function loginWordPress(username, password) {
		if (!validateInputs()) return;

		try {
			setLoginError('');
			setLoadingLogin(true);
			const response = await fetch(
				`${getWordpressData(institutionCode)}/wp-json/auth/v1/login`,
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ username, password }),
				}
			);

			const data = await response.json();

			if (!data?.user?.email) {
				setLoginError(t('Invalid credentials'));
				return;
			}

			const { user } = data;

			handleGetFavorites(user?.email, dispatch);
			dispatch(setUserEmail(user?.email));
			dispatch(setUserName(user?.name));
			dispatch(setActiveLoginModal(false));
			setLoginError('');
			navigate(`/articles`);

			return data;
		} catch (error) {
			setLoginError(t('Connection failed, try again later.'));
		} finally {
			setLoadingLogin(false);
		}
	}

	return {
		t,
		navigate,
		loginWordPress,
		setPassForm,
		setUsernameForm,
		passForm,
		usernameForm,
		usernameError,
		passwordError,
		loginError,
		loadingLogin,
	};
};
